export default String.raw`
{% assign tab = 'inquiries' -%}
{% assign pageQueryName = customer-profile.Inquiries.PageQueryGET -%}

{% include 'partials/common/date-format.html' -%}
{% assign inquiry = customer-profile.Offer -%}
{% assign inquiryString = customer-profile.OfferQueryGET -%}
{% assign queries = page.QueryString | Split: '&' -%}
{% for query in queries -%}
	{% if query contains 'page=' -%}
		{% assign pageQueryNo = query | Split: '=' | Last -%}
		{% break -%}
	{% else -%}
		{% assign pageQueryNo = 1 -%}
	{% endif -%}
{% endfor -%}

<div class="customer-submenu">
	<div class="customer-submenu__header submenu-header">
		<div class="navigation-header">
			<button aria-label="{{translations.Back}}" class="pure-button load-first-lvl-js parent-container-reload-js" data-template="partials/customer-profile/inquiries/inquiries.html" data-url="{{ page.Url }}?tab={{tab}}">
				<svg aria-hidden="true" width="24" height="24">
					<use href="css/img/fontawesome-icons.svg?v={{lqTS}}#long-arrow-left-{{settings.iconStyle}}"></use>
				</svg>
			</button>
			{{ translations.Inquiry }} {{ inquiry.Id }}
		</div>
	</div>
	<div class="order-details not-expandable">
		<div class="order-details__row">
			<div class="order-details-item">
				<div class="title">{{ translations.InquiryStatus }}</div>
				<span>{{ inquiry.StatusText | Capitalize }}</span>
				</div>
			<div class="order-details-item">
				<div class="title">{{ translations.BuyDate }}</div>
				<span>{{ inquiry.Date | Date:dateFormat }}</span>
			</div>
			{% assign relatedOffersSize = inquiry.RelatedOffers | Size -%}
			{% if relatedOffersSize > 0 and inquiry.Status != 10 -%}
			<div class="order-details-item">
				<div class="title">{{ translations.Offer }}</div>
					{% for relatedOffer in inquiry.RelatedOffers -%}
					<span>
						{{ relatedOffer.Id }}
					</span>
					<button class="pure-button replace-template-js set-focus-trap-js parent-container-reload-js" data-template="partials/customer-profile/offers/offer-details.html" data-url="{{ page.Url }}?{{customer-profile.OfferQueryGET}}={{ relatedOffer.Id }}&tab=offer-details"></span>
						{{ translations.SeeOfferDetails }}
					</button>
						{% if forloop.index != relatedOffersSize -%}, {% endif -%}
					{% endfor -%}
			</div>
			{% endif -%}

			<div class="order-details-item">
				<div class="title">{{ translations.BoughtBy }}</div>
				{% if inquiry.Name != '' -%}
					<span>{{ inquiry.Name }}</span>
				{% endif -%}
				{% if inquiry.Email != '' -%}
					<span>{{ inquiry.Email }}</span>
				{% endif -%}
				{% if inquiry.PhoneNo != '' -%}
					<span>{{ inquiry.PhoneNo }}</span>
				{% endif -%}
			</div>
		</div>
	</div>

	{% assign attachmentsSize = inquiry.Attachments | Size -%}
	{% if config.Orders.AttachmentsEnabled and attachmentsSize > 0 -%}
	<div class="attachements-container">
		<div class="title">{{ translations.Attachements }}</div>
		<div class="attachements">
			{% for file in inquiry.Attachments -%}
				{% assign type = file.Name | Split: '.' | Last | Downcase -%}
				{% if type == "jfif" or type == "jpe" or type == "jpeg" or type == "jpg" -%}
					{% assign icon = 'file-image' -%}
				{% elseif type == "csv" -%}
					{% assign icon = 'file-csv' -%}
				{% elseif type == "docx" or type == "odt" or type == "doc" -%}
					{% assign icon = 'file-word' -%}
				{% elseif type == "xlsx" or type == "ods" or type == "xls" -%}
					{% assign icon = 'file-spreadsheet' -%}
				{% elseif type == "zip" or type == "rar" or type == "7zip" -%}
					{% assign icon = 'file-archive' -%}
				{% elseif type == "pdf" -%}
					{% assign icon = 'file-pdf' -%}
				{% elseif type == "txt" -%}
        			{% assign icon = 'file-alt' -%}
				{% else -%}
        			{% assign icon = 'file' -%}
				{% endif -%}
				<div class="file-container file-container-js">
					{% capture fileHref -%}{% include 'partials/common/user-link.html', userLink: file.Url -%}{% endcapture -%}
					<a href="{{ fileHref }}">				
						<svg height="24" width="24" class="svgIcon">
							<use href="css/img/fontawesome-icons.svg?v={{lqTS}}#{{icon}}-{{settings.iconStyle}}"></use>
						</svg> 
						<span>{{ file.Name }}</span>
					</a>
				</div>
			{% endfor -%}
		</div>
	</div>
	{% endif -%}

	{% if inquiry.Message != "" -%}
	<div class="order-details-item">
		<div class="title">{{ translations.Remarks }}</div>
		<span>{{ inquiry.Message }}</span>
	</div>
	{% endif -%}

	<div class="order-products-list-js">
		{% include 'partials/order/products-partials/products.html' -%}
	</div>
</div>
`